module.exports = __webpack_public_path__ + "img/699e9911d0abade2924f08e09774dde8.3d29856c.png";